<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1">
<p class="Dedication"><em class="italic _idGenCharOverride-1">To my better half Sara <br/>and my beloved children Makda, Anja, Haben and Deborah</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781528957960_EPUB-1.vue?18508046